//-----------------------------
// Utilities & Data Access
//-----------------------------

// Fetch a single product param from the pre-loaded product list
function fetchProductParam(handle, param) {
    const product = window.builderProducts?.[handle];
    if (!product || !(param in product)) return null;
    return product[param];
}

// Sorts summary steps by index
function sortSummary() {
    const summaryList = document.querySelector('.builder-summary *[data-options]');
    const items = Array.from(summaryList.querySelectorAll('li[data-step]'));

    items.sort((a, b) => {
        return parseInt(a.dataset.step, 10) - parseInt(b.dataset.step, 10);
    });

    items.forEach(item => summaryList.appendChild(item));
}

function goToStep(step) {
    const stepElement = document.querySelector('.pool-builder article.step[data-step="' + step + '"]');
    stepElement.scrollIntoView({ behavior: 'smooth' });
}

function getMoneySeparators() {
    const format = window.moneyFormat || '${{amount}}';

    // We'll inject a known number and analyze the resulting string
    const probe = '1,234,567.89'; // default US format
    const sample = format.replace('{{amount}}', probe);

    const match = sample.match(/1(.?)234(.?)567(.?)89/);

    if (match) {
        return {
            thousandsSeparator: match[1] || ',', // between 1 and 234
            decimalSeparator: match[3] || '.',   // between 567 and 89
        };
    }

    // Fallback to US format
    return {
        thousandsSeparator: ',',
        decimalSeparator: '.',
    };
}

function formatPrice(cents) {
    const moneyFormat = window.moneyFormat || '${{amount}}';
    const separators = getMoneySeparators();
    const amount = cents / 100;

    // Split into parts
    const parts = amount
        .toFixed(2) // Always two decimals
        .split('.');

    let intPart = parts[0];
    const decimalPart = parts[1];

    // Add thousands separator manually
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, separators.thousandsSeparator);

    const formattedAmount = intPart + separators.decimalSeparator + decimalPart;

    return moneyFormat.replace('{{amount}}', formattedAmount);
}

function updateTotalPrice() {
    const checkedInputs = document.querySelectorAll('.pool-builder input[type="radio"]:checked:not([data-no-product])');

    let totalPrice = 0;
    let totalComparePrice = 0;

    // Add main product
    const mainProduct = window.builderProducts?.["main"];

    if (mainProduct) {
        const mainPrice = parseInt(mainProduct.price || 0, 10);
        const mainCompare = parseInt(mainProduct.compare_at_price || 0, 10);

        totalPrice += mainPrice;
        totalComparePrice += (mainCompare && mainCompare !== mainPrice) ? mainCompare : mainPrice;
    }

    // Add selected bundle items
    checkedInputs.forEach(input => {
        const handle = input.dataset.productHandle;
        const product = window.builderProducts?.[handle];

        if (!product || !product.available) return;

        const isFree = input.dataset.free === 'true';
        const price = parseInt(product.price || 0, 10);
        const compare = parseInt(product.compare_at_price || 0, 10);

        if (isFree) {
            // Free products don't add to totalPrice, only to totalComparePrice
            totalComparePrice += (compare && compare !== price) ? compare : price;
        } else {
            // Regular products add to both totals
            totalPrice += price;
            totalComparePrice += (compare && compare !== price) ? compare : price;
        }
    });


    // Display formatted prices
    const currentPriceSelectors = ['.builder-summary .total .value', '.sticky-cta .price__current'];
    const comparePriceSelectors = ['.sticky-cta .price__was'];

    currentPriceSelectors.forEach(selector => {
        const container = document.querySelector(selector);
        if (container) {
            container.textContent = formatPrice(totalPrice);
        }
    });

    comparePriceSelectors.forEach(selector => {
        const container = document.querySelector(selector);
        if (container) {
            if (totalComparePrice > totalPrice) {
                container.textContent = formatPrice(totalComparePrice);
                container.style.display = '';
            } else {
                container.style.display = 'none';
            }
        }
    });
}

function setStickyTitle() {
    document.querySelector(".sticky-cta .title").innerHTML = stickyCTALabel;
}

//-----------------------------
// Template Renderers
//-----------------------------

// Creates the step header markup
function renderStepHeader(step) {
    return `
        <header>
            <p>${stepLabel} ${step.index} : ${step.title}</p>
            <small>${step.text}</small>
            <img class="collapser" src="${collapseImage}" alt="Collapse">
        </header>`;
}

// Create the sub-step nav markup
function renderBuilderNav(step) {
    let index = 0;
    const navItems = step.categories.map((cat, index) => {
        const availableProducts = (Array.isArray(cat.product_list) ? cat.product_list : [])
        .map(handle => window.builderProducts?.[handle])
        .filter(product => product && product.available);
    
        const hasProducts = availableProducts.length > 0;
        const image = hasProducts
            ? availableProducts[0].featured_image || fallbackImage
            : fallbackImage;

        return `
            <li data-sub-step="${step.index}-${index}" data-has-products="${hasProducts}">
                <figure>
                    <img src="${image}" alt="${cat.category_title || 'Option'}">
                </figure>
                <span>${cat.category_title || '${noOptionLabel}'}</span>
            </li>`;
    }).join('');

    return `
        <nav><ul>${navItems}</ul></nav>
    `;        
}

function renderProduct(handle, step, i) {
    if (handle == null) {
        return `
            <li>
            <input type="radio" id="none-${step.index}" name="step-${step.index}" data-no-product="true">
            <label for="none-${step.index}">
            <figure><img src="${fallbackImage}" alt="Aucune option"></figure>
            <div class="info">
                <h4>${noOptionLabel}</h4>
            </div>
            </label>
            </li>`;
    } else {
        const product = window.builderProducts?.[handle];

        if (!product) {
            console.warn(`Product not found for handle: ${handle}`);
            return '';
        }

        if (!product.available) return '';

        const productTitle = product.short_title || product.title;

        return `
            <li>
            <input type="radio" id="product-${product.id}-${step.index}-${i}" name="step-${step.index}" data-product-handle="${handle}" data-variant-id="${product.variant_id}" data-free="${step.free ? 'true' : 'false'}">
            <label for="product-${product.id}-${step.index}-${i}">
            <figure>
            <img src="${product.featured_image || '/cdn/shop/files/placeholder.jpg'}" alt="${product.title}">
            </figure>
            <div class="info">
            <h4>${productTitle}</h4>
            <p>${product.reviews_badge || ''}</p>
            ${!step.free ? `
                <p style="margin-bottom: 0;">
                    <span class="price">${formatPrice(product.price)}</span>
                    ${product.compare_at_price && product.compare_at_price !== product.price ? `<span class="compare">${formatPrice(product.compare_at_price)}</span>` : ''}
                </p>` : ''
            }
            </div>
            </label>
            </li>`; 
    }
}

function renderProductList(step) {
    let index = 0;

    if (step.categories && Array.isArray(step.categories)) {
        // Return an array of fieldsets, one for each category
        return step.categories.map(category => {
            if (!Array.isArray(category.product_list) || category.product_list.length === 0) return null;
            const fieldset = document.createElement('fieldset');
            fieldset.classList.add('product-list');
            fieldset.dataset.subStep = `${step.index}-${index}`;

            const ul = document.createElement('ul');

            if (category.product_list && Array.isArray(category.product_list)) {
                category.product_list.forEach(handle => {
                    ul.insertAdjacentHTML('beforeend', renderProduct(handle, step, index));
                    index++;
                });
            }

            // If no products were rendered, show a fallback message
            if (ul.children.length === 0) {
                const message = document.createElement('div');
                message.className = 'no-products';
                message.textContent = noProductsLabel;
                fieldset.appendChild(message);
                return fieldset;
            }

            fieldset.appendChild(ul);
            return fieldset;

        }).filter(Boolean); // Filter out any null values
    } else {
        // Single fieldset for basic product_list
        const fieldset = document.createElement('fieldset');
        fieldset.classList.add('product-list');

        const ul = document.createElement('ul');

        if (!step.required) {
            ul.insertAdjacentHTML('beforeend', renderProduct(null, step, index++));
        }

        step.product_list.forEach(handle => {
            ul.insertAdjacentHTML('beforeend', renderProduct(handle, step, index++));
        });

        // If no products were rendered, show a fallback message
        if (ul.children.length === 0) {
            const message = document.createElement('div');
            message.className = 'no-products';
            message.textContent = noProductsLabel;
            fieldset.appendChild(message);
            return fieldset;
        }

        fieldset.appendChild(ul);
        return fieldset;
    }
}

// Main function to render the builder
function renderBuilderSteps(builderStructure, builderProducts) {
    const container = document.getElementById('builder-container');
    if (!container || !builderStructure?.steps) return;

    // Building each step
    builderStructure.steps.forEach(step => {
        let stepElem = document.createElement('article');
        stepElem.className = 'step';
        stepElem.dataset.step = step.index;

        stepElem.insertAdjacentHTML('beforeend', renderStepHeader(step));

        if (step.categories) {
            stepElem.insertAdjacentHTML('beforeend', renderBuilderNav(step));
        }

        const productLists = renderProductList(step);

        if (Array.isArray(productLists)) {
            productLists.forEach(list => stepElem.appendChild(list));
        } else {
            stepElem.appendChild(productLists);
        }

        container.appendChild(stepElem);
        initStepCategories(stepElem);
    });
}

function renderFreebies(builderStructure, builderProducts) {
    const inputContainer = document.getElementById('builder-container');
    const freebieContainer = document.querySelector('.builder-freebies');
    if (!inputContainer || !builderStructure?.freebies) return;

    freebieContainer.classList.remove('hidden');

    builderStructure.freebies.product_handles.forEach(freebie => {
        const product = window.builderProducts?.[freebie];

        if (!product || !product.available) return;

        const freebieElem = `
            <li>
                <figure>
                    <img src="${product.featured_image || '/cdn/shop/files/placeholder.jpg'}" alt="${product.title}">
                </figure>
                <p>${product.short_title || product.title}</p>
                <p>${formatPrice(product.price)}</p>
                <em>${freeLabel}</em>
            </li>
        `;

        freebieContainer.querySelector('ul').insertAdjacentHTML('beforeend', freebieElem);
    });

    const bundleProduct = window.builderProducts?.[builderStructure.freebies.bundle_handle];
    const freebieInput = `
        <input class="hidden" type="radio" id="product-${bundleProduct.id}-freebie" data-product-handle="${builderStructure.freebies.bundle_handle}" data-variant-id="${bundleProduct.variant_id}" data-free="true" checked>
    `;
    inputContainer.insertAdjacentHTML('beforeend', freebieInput);
}

function renderIncludes(builderStructure, builderProducts) {
    const container = document.querySelector('.builder-includes ul');
    if (!container || !builderStructure?.includes) return;
    builderStructure.includes.forEach(include => {
        const li = document.createElement('li');
        li.innerHTML = include;

        container.appendChild(li);
    });

    if (!builderStructure?.freebies) return;

    builderStructure.freebies.forEach(freebie => {
        const product = window.builderProducts?.[freebie];

        if (!product || !product.available) return;

        const freebieElem = `
            <li>${product.title} - <span>${freeLabel}</li>
        `;
        container.insertAdjacentHTML('beforeend', freebieElem);
    });    
}

//-----------------------------
// Step Interaction Logic
//-----------------------------

// Initialize the step categories
function initStepCategories(stepElem) {
    const navItems = stepElem.querySelectorAll('nav li[data-sub-step]');
    const fieldsets = stepElem.querySelectorAll('fieldset');

    if (navItems.length === 0) return;

    // Hide all fieldsets initially
    fieldsets.forEach(fs => fs.classList.add('-hidden'));

    // Show the first one
    fieldsets[0].classList.remove('-hidden');
    navItems[0].classList.add('-active');

    navItems.forEach((navItem, index) => {
        navItem.addEventListener('click', () => {
            navItems.forEach(item => item.classList.remove('-active'));
            fieldsets.forEach(fs => fs.classList.add('-hidden'));

            navItem.classList.add('-active');
            fieldsets[index]?.classList.remove('-hidden');

            const hasProducts = navItem.dataset.hasProducts === 'true';

            if (!hasProducts) {
                const step = navItem.closest('article.step');
                step.querySelectorAll('.product-list input[type="radio"]').forEach(input => {
                    input.checked = false;
                });
            }
        });
    });
}

function initBuilder() {
    // Activating the first step
    document.querySelector(".step[data-step='1']").classList.add('-open');
    // Collapsing steps
    document.querySelectorAll('.pool-builder .step').forEach(step => {
            const header = step.querySelector('header');
            
            header.addEventListener('click', () => {
            step.classList.toggle('-open');

            // Used to prevent scrollbar flickering
            step.classList.add('-animating');
            setTimeout(() => {
                step.classList.remove('-animating');
            }, 250);
        });
    });

    // Selecting nav elements
    document.querySelectorAll('.pool-builder .step').forEach(step => {
        const listItems = step.querySelectorAll('nav li');

        listItems.forEach(item => {
            item.addEventListener('click', () => {
                // Remove 'active' from all siblings
                listItems.forEach(li => li.classList.remove('-active'));
                // Add it to the clicked one
                item.classList.add('-active');
            });
        });
    });

    document.querySelectorAll('.pool-builder .product-list input[type="radio"]').forEach(input => {
        input.addEventListener('change', e => handleProductClick(e.target));
    });

    document.querySelectorAll('.pool-builder nav li').forEach(nav => {
        nav.addEventListener('click', function(event) {
            const target = event.target.closest('li[data-has-products="false"]');
            if (target) {
                handleProductClick(target);
            }
        });
    });
}

//-----------------------------
// Selection & Summary Logic
//-----------------------------

function handleProductClick(target) {
    const stepArticle = target.closest('article.step');
    if (!stepArticle) return;

    const currentStepIndex = parseInt(stepArticle.dataset.step, 10);
    const nextStep = document.querySelector(`article.step[data-step="${currentStepIndex + 1}"]`);

    // Case 1: If it's a radio button and not a "no-product" option
    if (target.matches('input[type="radio"]') && target.dataset.noProduct !== "true") {
        addProductToSummary(target, currentStepIndex);
    }

    // Case 2: It's a "no-product" radio button
    if (target.matches('input[type="radio"]') && target.dataset.noProduct === "true") {
        removeProductFromSummary(currentStepIndex);
    }

    // Case 3: It's a category with no products
    if (target.dataset.hasProducts === "false") {
        removeProductFromSummary(currentStepIndex);
    }

    // Dispatch event for other systems (price, UI, analytics, etc)
    document.dispatchEvent(new CustomEvent('builder:selectionChanged'));

    if (nextStep) {
        setTimeout(() => {
            nextStep.classList.add('-open');

            const scrollOffset = 85;
            const elementPosition = nextStep.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - scrollOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }, 150);
    } else {
        setTimeout(() => {
            const scrollOffset = 85;
            const elementPosition = document.querySelector('.builder-includes').getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - scrollOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }, 150);
    }
}

// Builder Summary Logic

function addProductToSummary(elem, step) {
    const handle = elem.dataset.productHandle;
    const product = window.builderProducts?.[handle];
    const summaryList = document.querySelector('.builder-summary *[data-options]');
    const free = elem.dataset.free === 'true';

    if (!product) {
        console.warn("No product found for handle:", handle);
        return;
    }

    if (!summaryList) {
        console.warn('Summary list not found when trying to update summary');
        return;
    }

    const productTitle = product.short_title || product.title;

    const productLine = `
        <li data-step="${step}">
            <span class="title">${productTitle}</span>
            ${!free ? `
                <span class="prices">
                    <span class="price">${formatPrice(product.price)}</span>
                    ${product.compare_at_price && product.compare_at_price !== product.price
                        ? `<span class="compare">${formatPrice(product.compare_at_price)}</span>`
                        : ''}
                </span>` : ''}
            <a onclick="goToStep(${step});">${modifyLabel}</a>
        </li>`;

    const existing = summaryList.querySelector('li[data-step="' + step + '"]');
    if (existing) {
        existing.outerHTML = productLine;
    } else {
        summaryList.insertAdjacentHTML('beforeend', productLine);
    }

    sortSummary();
}

function removeProductFromSummary(step) {
    const summaryList = document.querySelector('.builder-summary *[data-options]');
    const item = summaryList.querySelector(`li[data-step="${step}"]`);
    if (item) {
        item.remove();
    }
}

//-----------------------------
// Countdown
//-----------------------------

function updateCountdown() {
    const countdownElement = document.getElementById('promo-countdown');
    const now = new Date();

    // Fixed reference date (choose a consistent anchor point)
    const referenceDate = new Date(2025, 4, 15, 0, 0, 0);
    const msInDay = 24 * 60 * 60 * 1000;
    const msIn15Days = 15 * msInDay;

    // Calculate elapsed time and current cycle
    const timeElapsed = now - referenceDate;
    const cyclesPassed = Math.floor(timeElapsed / msIn15Days);
    const currentCycleStart = new Date(referenceDate.getTime() + cyclesPassed * msIn15Days);
    const nextCycleStart = new Date(currentCycleStart.getTime() + msIn15Days);
    const timeRemaining = nextCycleStart - now;

    // Break down time
    const days = Math.floor(timeRemaining / msInDay);
    const hours = Math.floor((timeRemaining % msInDay) / (60 * 60 * 1000));
    const minutes = Math.floor((timeRemaining % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((timeRemaining % (60 * 1000)) / 1000);

    // Determine language from <html lang="...">
    const lang = document.documentElement.lang || 'en';

    // Localization
    let dayLabel, remainingLabel;
    if (lang.startsWith('fr')) {
      dayLabel = days === 1 ? 'jour' : 'jours';
      remainingLabel = 'restant';
    } else {
      dayLabel = days === 1 ? 'day' : 'days';
      remainingLabel = 'remaining';
    }

    // Format string
    const formattedTime = `${days} ${dayLabel} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${remainingLabel}`;

    countdownElement.textContent = formattedTime;
}

//-----------------------------
// Initialization
//-----------------------------

document.addEventListener('DOMContentLoaded', () => {
    renderBuilderSteps(window.builderStructure, window.builderProducts);
    renderFreebies(window.builderStructure, window.builderProducts);
    updateTotalPrice();
    initBuilder();
    renderIncludes(window.builderStructure, window.builderProducts);

    updateCountdown();
    setInterval(updateCountdown, 1000);

    document.addEventListener('builder:selectionChanged', function() {
        updateTotalPrice();
        setStickyTitle();
    });

    // Init Simplebars
    Array.prototype.forEach.call(
        document.querySelectorAll('.pool-builder .product-list'),
        (el) => new SimpleBar(el, {
            autoHide: false
        })
    );
});